/* eslint-disable vue/valid-v-for */
<template>
  <div>
    <b-modal
      full-screen
      has-modal-card
      :can-cancel="false"
      :active="expanded"
      animation="slide-next"
    >
      <div class="menu-layout modal-card">
        <menu-toolbar @on-click="closeModal"></menu-toolbar>
        <menu-user-info
          name="Javier Mendoza Licea"
          credential="#7678878768998687"
        ></menu-user-info>
        <div class="scrollable-content">
          <menu-item
            v-for="item in menuItems"
            :key="item.id"
            :item="item"
            @item-click="handleItemClick"
          ></menu-item>
        </div>
        <div class="div-info-button" @click="navigateManual()">
          <b-icon class="info-icon" icon="help-circle"></b-icon>
          <b-button class="info-button" type="" @click="navigateManual()"
            >Consulta manual</b-button
          >
        </div>

        <span class="footer-text gray has-text-centered mb-3">{{
          appVersion
        }}</span>

        <b-button
          class=""
          expanded
          type="is-danger is-light"
          @click="openSignoutAlert"
          >Salir</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import MenuToolbar from '@/components/navigation/mobile/MenuToolbar.vue'
import MenuUserInfo from '@/components/navigation/mobile/MenuUserInfo.vue'
import MenuItem from '@/components/navigation/mobile/MenuItem.vue'
import { ItemMenu } from '@/store/navigation/types'
import { NavigationMutations } from '@/store/navigation/mutations'
import { mapActions, mapState, mapMutations } from 'vuex'
import { ENV } from '@/config'

export default Vue.extend({
  name: 'MobileMenu',

  components: { MenuToolbar, MenuUserInfo, MenuItem },

  data() {
    return {
      menuVisible: true
    }
  },

  methods: {
    ...mapActions('navigation', ['setSidebarExpanded']),
    ...mapMutations('navigation', [NavigationMutations.SET_ACTIVE_MENU]),
    ...mapActions(['signout']),
    ...mapMutations(['SHOW_SIGNOUT_DIALOG']),

    closeModal() {
      this.setSidebarExpanded(false)
    },

    openSignoutAlert() {
      this.closeModal()
      this.$buefy.dialog.confirm({
        title: 'Cerrar sesión',
        message:
          'La sesión actual será finalizada y se enviará a la pantalla de acceso ¿Deseas continuar?',
        confirmText: 'Salir',
        cancelText: 'Cancelar',
        type: 'is-warning',
        hasIcon: true,
        onCancel: () => this.SHOW_SIGNOUT_DIALOG(false),
        onConfirm: () => this.signout()
      })
    },

    handleItemClick(item: ItemMenu) {
      if (this.$route.path != (item.to as string)) {
        this.$router.push(item.to as string)
      }
      this.SET_ACTIVE_MENU(item)
      this.closeModal()
    },

    navigateManual() {
      window.open('https://ayuda.lumineapp.com/ayuda_app_doctores/', '_blank')
    }
  },

  computed: {
    ...mapState('navigation', ['menuItems', 'expanded']),
    appVersion(): string {
      return 'version ' + ENV.appVersion
    }
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style

.menu-layout
    display: flex
    flex-direction: column
    height: 100vh
    background: $white

.info-button
  background-color: $background
  border: none
  height: auto
  display: inline-block
  font-size: 14px
  margin-top: 2px

.info-icon
  display: inline-block
  margin-top: 0px
  font-size: 10px

.div-info-button
  display: inline-block
  width: 175px
  position: relative
  margin-top: auto
  color: $gray
  text-align: centers
  margin-bottom: 10px
  margin-left: auto
  margin-right: auto

.scrollable-content
  max-height: 100%
  overflow-y: scroll
  padding-bottom: 6px
  background: $white
</style>
